var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainHubWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    className: "st0",
    d: "M18.1,36C8.1,36,0,27.9,0,18c0-4.8,1.9-9.4,5.3-12.7c0.9-0.9,2.4-0.9,3.3,0 c0.9,0.9,0.9,2.4,0,3.3l0,0c-5.2,5.2-5.2,13.7,0,18.9s13.8,5.2,19,0s5.2-13.7,0-18.9c-2.5-2.5-5.9-3.9-9.5-3.9 c-1.3,0.1-2.4-0.9-2.4-2.2s0.9-2.3,2.2-2.4c0.1,0,0.1,0,0.2,0c10,0.1,18,8.2,17.9,18.1C35.9,28,27.9,35.9,18.1,36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHubWhite);
export default __webpack_public_path__ + "static/media/MainHub_White.0636fed004ac61cfb6a192d559d4c83d.svg";
export { ForwardRef as ReactComponent };